import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { GoldButton } from "../GoldButton";
import { SITE, IMAGES, waLink } from "../../config/site";

const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};

export const Hero = () => {
  const reduce = useReducedMotion();
  const item = {
    hidden: reduce ? { opacity: 0 } : { opacity: 0, y: 28, filter: "blur(8px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
    },
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-center overflow-hidden bg-ink"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Atleta ajustando a faixa preta do kimono"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-ink/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-ink/60" />
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        animate="show"
        className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-28 pb-20"
      >
        <motion.h1
          variants={item}
          className="font-display text-cream uppercase tracking-tight leading-[0.92] mt-7 text-5xl sm:text-6xl md:text-7xl lg:text-8xl max-w-4xl"
        >
          Jiu-jitsu
          <br />
          <span className="text-gold-light">para a vida real</span>
        </motion.h1>

        <motion.p
          variants={item}
          className="font-body text-cream/70 text-base md:text-lg leading-relaxed mt-7 max-w-2xl"
        >
          A Templo Jiu-Jitsu Culture está chegando a Belo Horizonte/MG, na
          Savassi. Do primeiro dia ao faixa-preta, com turmas pensadas pra quem
          vive de verdade — inclusive 40+, pais &amp; filhos e mulheres.
        </motion.p>

        <motion.div
          variants={item}
          className="flex flex-col sm:flex-row gap-4 mt-10"
        >
          <GoldButton
            href={waLink(
              "Oi! Quero garantir minha aula experimental na Templo Savassi."
            )}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-primary"
          >
            Garantir minha aula experimental
            <ArrowRight size={18} weight="bold" />
          </GoldButton>
        </motion.div>

        <motion.p
          variants={item}
          className="font-body text-sm text-cream/60 mt-6 flex items-start gap-x-2.5"
          data-testid="hero-dates"
        >
          <span className="text-gold-light leading-6 shrink-0">●</span>
          <span className="leading-6">
            Inauguração {SITE.opening} · Início das aulas {SITE.classesStart}
          </span>
        </motion.p>
      </motion.div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <div className="w-[1px] h-12 bg-gradient-to-b from-transparent via-gold-light/60 to-transparent" />
      </div>
    </section>
  );
};
